import React, { useEffect, useState } from 'react';
import { IBaasSignup } from '../../services/BaasSignupService';
import { useDispatch, useSelector } from 'react-redux';
import { incrementBaasStep, initBaasSignup, selectBaasSignup, selectBaasStep } from './baasSignupSlice';
import { SignupPassword } from '../../components/registration/SignupPassword';
import { BaasSignupParamsHandler } from './BaasSignupParamsHandler';
import { setRedirectError } from '../redirectError/redirectErrorSlice';
import { RegistrationErrorHandler } from '../../components/registration/RegistrationErrorHandler';
import { Hmi } from '../hmi/Hmi';
import { HmiType } from '../hmi/hmi.interface';
import { getMobileOperatingSystem, getParameterByName } from '../../utils/WindowHelper';
import { http } from '../../services/BackendService';
import { signupError } from '../../utils/ErrorHandling';
import { LoadingScreenSignup } from '../../components/shared/LoadingScreen/LoadingScreenSignup';
import { AUTH_API_URL } from '../../app.config';

type Props = {
  path?: string;
};

export const BaasSignup: React.FC<Props> = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const signup = useSelector(selectBaasSignup);
  const step = useSelector(selectBaasStep);
  const [signupDone, setSignupDone] = useState(false);
  const [nextStep, setNextStep] = useState<string | undefined>('');
  const dispatch = useDispatch();

  const handleSignup = async (signup: IBaasSignup) => {
    let url = `${AUTH_API_URL}/api/services/baas/signup`;

    signup.platform = getMobileOperatingSystem();

    const args: RequestInit = {
      method: 'POST',
      cache: 'no-cache',
      body: JSON.stringify(signup),
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    };

    try {
      const res = await http<IBaasSignup>(new Request(url, args));

      if (res.parsedBody) {
        setSignupDone(true);
        setNextStep(res.parsedBody.nextStep);
      }
    } catch (error) {
      signupError(error.value || 0);
    }
  };

  const signupSuccess = () => {
    const redirect = getParameterByName('redirect_uri');

    window.location.href = nextStep || redirect + '?error=hat_provisioning&error_reason=next_step_undefined';
  };

  const passwordNext = (password: string) => {
    const newSignupState: IBaasSignup = Object.assign({}, signup);
    newSignupState.password = password;

    dispatch(initBaasSignup(newSignupState));
    dispatch(incrementBaasStep(1));
  };

  useEffect(() => {
    if (step === 2 && !isSubmitting) {
      handleSignup(Object.assign({}, signup));

      setIsSubmitting(true);
    }

    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [step]);

  return (
    <BaasSignupParamsHandler>
      <RegistrationErrorHandler>
        {step === 0 && (
          <SignupPassword
            passwordNext={passwordNext}
            cancelClicked={() => dispatch(setRedirectError({ error: 'access_denied', reason: 'user_cancelled' }))}
          />
        )}

        {step === 1 && <Hmi applicationId={signup.applicationId} hmiType={HmiType.baas} />}

        {step === 2 && <LoadingScreenSignup done={signupDone} hundredPercent={() => signupSuccess()} />}
      </RegistrationErrorHandler>
    </BaasSignupParamsHandler>
  );
};
